// extracted by mini-css-extract-plugin
export var classCardContainer = "styles-module--classCardContainer---O+Ss";
export var classCardWrapper = "styles-module--classCardWrapper--pMh-1";
export var heading = "styles-module--heading--578ou";
export var description = "styles-module--description--hXmrK";
export var tag = "styles-module--tag--CeO5K";
export var dateContainer = "styles-module--dateContainer--QmcIh";
export var teacher = "styles-module--teacher--thLC9";